import React from 'react';
import Errorimg from '../assets/images/404Error.gif';
import { useNavigate } from 'react-router-dom';
const ErrorPage = () => {
    const navigate = useNavigate();
    return (
        <div className='w-full h-screen flex-col flex items-center justify-center'>
            <div>
                <img src={Errorimg} alt='404Error' title='404Error' />
            </div>
            <div>
                <button onClick={() => { navigate('/') }} type='button' className='bg-sky-400 border-2 border-transparent hover:border-sky-400 font-semibold hover:bg-white hover:text-sky-400 transition-all text-white text-[18px] flex justify-center items-center px-[15px] h-[40px] rounded-full capitalize first-letter:text-[22px] my-[20px]'>Go To Home Page</button>
            </div>
        </div>
    );
};

export default ErrorPage;